import 'jquery-placeholder';

const self = {};

self.setPlaceholders = function setPlaceholders($labels) {
  $.each($labels, function each() {
    const $label = $(this);

    // Get the for attribute
    const forAttr = $label.attr('for');

    // Get the label's text
    const text = $label.html();

    if (text.length > 0) {
      // Use this to find the associated input
      const $input = $(`#${forAttr}`);

      // If we've found the input, set the placeholder text
      if ($input) {
        // Get the current placeholder text
        const placeholder = $input.attr('placeholder');

        // Only reset the placeholder if the current placeholder is empty (we've not chosen one)
        if (!placeholder || placeholder.length <= 0) {
          $input.attr('placeholder', text);
          $input.placeholder();
        }
      }
    }
  });
};

// On page load, set placeholders for hidden labels
self.setPlaceholders($('label.sr-only, label.hidden'));

export default self;
